import React from "react"

import ReadAloud from "../../components/ReadAloud/ReadAloud";

const Advisors = ({fontSize}) => {
    return (
        <div>
            <ReadAloud fontSize={`${16+fontSize}px`}>
            <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Dr. Barbara Moffatt | Professor | Department of Biology</h4>
            <ul className="page-text">
            <li>Assessed feasibility in project selection process</li>
            <li>Provided project feedback at various times throughout the year</li>
            <li>Provided troubleshooting suggestions for PCR procedures</li>
            <li>Helped critique general project direction</li>
            </ul>
            </ReadAloud>

            <ReadAloud fontSize={`${16+fontSize}px`}>
            <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Dr. Bernard Duncker | Professor | Department of Biology</h4>
            <ul className="page-text">
            <li>Provided expertise in all yeast-related protocols and procedure design</li>
            </ul>
            </ReadAloud>

            <ReadAloud fontSize={`${16+fontSize}px`}>
            <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Dr. Brian Ingalls | Professor | Department of Applied Mathematics</h4>
            <ul className="page-text">
            <li>Assessed feasibility in project selection process</li>
            <li>Provided project feedback at various times throughout the year</li>
            <li>Aided in administrative and financial upkeep</li>
            <li>Provided assistance with metabolic pathway modelling and bioreactor design</li>
            </ul>
            </ReadAloud>

            <ReadAloud fontSize={`${16+fontSize}px`}>
            <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Dr. Forbes Burkowski | Associate Professor Emeritus | Cheriton School of Computer Science</h4>
            <ul className="page-text">
            <li>Assessed feasibility in project selection process</li>
            <li>Provided project feedback at various times throughout the year</li>
            </ul>
            </ReadAloud>

            <ReadAloud fontSize={`${16+fontSize}px`}>
            <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Monika Bothwell | Faculty Financial Officer | Faculty of Science</h4>
            <ul className="page-text">
            <li>Handled team finances and transactions</li>
            </ul>
            </ReadAloud>

            <ReadAloud fontSize={`${16+fontSize}px`}>
            <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Dr. Trevor Charles | Professor | Department of Biology</h4>
            <ul className="page-text">
            <li>Assessed feasibility in project selection process</li>
            <li>Provided project feedback at various times throughout the year</li>
            </ul>
            </ReadAloud>

            <ReadAloud fontSize={`${16+fontSize}px`}>
            <h4 style={{fontSize: `${20+fontSize}px`}} className="page-name">Dr. Valerie Ward | Assistant Professor | Department of Chemical Engineering</h4>
            <ul className="page-text">
            <li>Provided advice on product quantification, membrane transport system design, and plasmid construction</li>
            </ul>
            </ReadAloud>
        </div>
    )
}

export default Advisors